<template>
  <div class="digisac-container"></div>
</template>

<script>
export default {
  name: 'DigisacWidget',
  data() {
    return {
      isLoaded: false
    }
  },
  mounted() {
    this.initDigisac();
  },
  methods: {
    getUserInfo(field, defaultValue = '') {
        const userData = JSON.parse(localStorage.getItem('user'));
        return userData && userData[field] ? userData[field] : defaultValue;
    },
    initDigisac() {
      if (this.isLoaded) return;

      window._digisac = {
        id: "c63a6255-6da1-46bc-8107-5a49b5d11476",
        payload: {
          startOpen: false,
          contact: {
            name: this.getUserInfo('name'),
            email: this.getUserInfo('email'),
            phone: this.getUserInfo('phone')
          },
        }
      };

      const script = document.createElement('script');
      script.setAttribute('src', 'https://webchat.digisac.app/embedded.js');
      script.onload = () => {
        this.isLoaded = true;
        console.log('Script Digisac carregado com sucesso');
      };
      script.onerror = (error) => {
        console.error('Erro ao carregar o script Digisac:', error);
      };

      document.head.appendChild(script);
    }
  },
  beforeDestroy() {
    const widgetContainer = document.querySelector('.close-widgets-container');
    if (widgetContainer) {
      document.body.removeChild(widgetContainer);
    }

    const digisacScript = document.querySelector('script[src="https://webchat.digisac.app/embedded.js"]');
    if (digisacScript) {
      document.head.removeChild(digisacScript);
    }
  }
}
</script>

<style scoped>
</style>